import { render, staticRenderFns } from "./zbt.vue?vue&type=template&id=201b8532&scoped=true"
import script from "./zbt.vue?vue&type=script&lang=js"
export * from "./zbt.vue?vue&type=script&lang=js"
import style0 from "./zbt.vue?vue&type=style&index=0&id=201b8532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b8532",
  null
  
)

export default component.exports